import React from "react";
import Chart from "react-apexcharts";
import ChartCard from "./ChartCard";
import { baseChartOptions } from "./chartTheme";

const CHART_ID = "cases-status-by-week";

interface StatusData {
  week: string;
  passed?: number;
  failed?: number;
  other?: number;
  PASSED?: number;
  FAILED?: number;
  OTHER?: number;
}

interface CasesStatusByWeekChartProps {
  data?: StatusData[];
}

const CasesStatusByWeekChart: React.FC<CasesStatusByWeekChartProps> = ({
  data = [],
}) => {
  const safeData: StatusData[] =
    data.length > 0
      ? data
      : [{ week: "Week 1", passed: 0, failed: 0, other: 0 }];

  const categories = safeData.map((item) => item.week || "Week ?");

  const passedData = safeData.map((item) =>
    item.passed !== undefined
      ? item.passed
      : item.PASSED !== undefined
      ? item.PASSED
      : 0
  );
  const failedData = safeData.map((item) =>
    item.failed !== undefined
      ? item.failed
      : item.FAILED !== undefined
      ? item.FAILED
      : 0
  );
  const otherData = safeData.map((item) =>
    item.other !== undefined
      ? item.other
      : item.OTHER !== undefined
      ? item.OTHER
      : 0
  );

  const series = [
    { name: "Passed", data: passedData },
    { name: "Failed", data: failedData },
    { name: "Queue", data: otherData },
  ];

  const base = baseChartOptions(CHART_ID);
  const options = {
    ...base,
    chart: { ...base.chart, type: "bar", stacked: false },
    colors: ["#15803d", "#dc2626", "#b45309"],
    xaxis: { type: "category", categories: categories },
    plotOptions: {
      bar: { horizontal: false, columnWidth: "55%", borderRadius: 6 },
    },
  };

  return (
    <ChartCard
      title="Test Cases Status by Week"
      description="Shows weekly counts for passed, failed, and other test cases."
      chartId={CHART_ID}
    >
      <Chart options={options} series={series} type="bar" height={300} />
    </ChartCard>
  );
};

export default CasesStatusByWeekChart;
